import React from "react";
import {
  MAIN_ITEM_MAIN_SECTION,
  MAIN_ITEM_PARENT,
  MAIN_ITEM_SECTION,
} from "../menus";
import MainSectionTitle from "./MainSectionTitle";
import MenuItem from "./MenuItem";
import ParentItem from "./ParentItem";
import SectionItemTitle from "./SectionItemTitle";

const Item = ({ type, ...other }) => {
  if (type === MAIN_ITEM_PARENT) {
    return <ParentItem {...other} />;
  }
  if (type === MAIN_ITEM_SECTION) {
    return <SectionItemTitle {...other} />;
  }
  if (type === MAIN_ITEM_MAIN_SECTION) {
    return <MainSectionTitle {...other} />;
  }

  return <MenuItem {...other} />;
};

export default Item;
